<div class="noa__wrapper w-100">
	<div class="noa__location">
		<span>LPOC</span><br>
		<b>{{ LPOC() }}</b>
	</div>
	<div class="position-relative w-100"
		 style="height: 36px;">
		<ul class="noa__stepper">
			<ol>
				<div class="bg-green noa__icon"></div>
			</ol>
			
			<!-- @for (step of steps(); track $index; let i = $index) {
				@if (step.movementStep.visible) {
					<ol [ngClass]="{ 'invisible': !step.movementStep.visible }">
						<button kendoButton
								#anchor
								[size]="'small'"
								[rounded]="'full'"
								[themeColor]="'success'"
								[icon]="'plus'"
								(click)="onAddMovement(i)">
						</button>

						@if (showAddMovementPopup(i)) {
							<kendo-popup [anchor]="anchor.element">
								<pmis3-vessel-visit-stepper-popup [insertPosition]="step.movementStep.indexInPairsArray || 0"
																[(activePopupIndex)]="activePopupIndex">
								</pmis3-vessel-visit-stepper-popup>
							</kendo-popup>
						}

						<span>{{ step.movementStep.text }}</span>
					</ol>
				}

				@if (step.stopStep?.visible) {
					<ol [ngClass]="{ 'invisible': !step.stopStep?.visible }"
						class="position-relative">
						<button kendoButton
								[size]="'small'"
								[rounded]="'full'"
								[themeColor]="'success'"
								(click)="onSelectStop()">
						</button>
						<ng-container [ngTemplateOutlet]="summary"
									  [ngTemplateOutletContext]="{ vesselStopId: step.stopStep?.indexInPairsArray }">
						</ng-container>
					</ol>
				}
			} -->

			
			@for (item of steps(); track $index; let i = $index) {
				<ol [ngClass]="[
					getColorOfStop(item),
					getBorderColorOfStop(item),
					!item.visible ? 'invisible' : '',
					state().selectedStep() === i ? 'selected' : ''
				]">
				@if(item.label === "icon") {
						<button kendoButton #anchor
								[size]="'small'"
								[rounded]="'full'"
								[icon]="'plus'"
								(click)="onAddMovement(i)"
								class="noa__add-movement movement-button"
								[ngClass]="disabled() ? 'bg-green-disabled' : 'bg-green-dark'"
								[disabled]="disabled()">
						</button>
						@if (i === activePopupIndex()) {
							<kendo-popup [anchor]="anchor.element">
								<pmis3-vessel-visit-stepper-popup [insertPosition]="item.indexInArray" 
																  [(activePopupIndex)]="activePopupIndex"
								></pmis3-vessel-visit-stepper-popup>
    						</kendo-popup>
						}
						<span>{{item.text}}</span>
				} @else {
					@if(readonly()) { 
						<div class="noa__label text-white">
							{{item.text}}
							<ng-container [ngTemplateOutlet]="summary"
										  [ngTemplateOutletContext]="{ 
											vesselStop: item.stop, 
											vesselMovement: item.arrivalMovementToStop, 
											stopType: item.label, 
											stopNumber: item.stopNumber, 
											inEditMode: !readonly(),
											indexInArray: item.indexInArray}">
							</ng-container>
						</div>
					} @else {
						<button kendoButton
								[size]="'none'"
								[rounded]="'full'"
								[fillMode]="'clear'"
								(click)="onSelectStop(item.indexInArray)"
								class="w-100 h-100 line-height-1 bg-transparent"
								[disabled]="disabled()">
							{{ item.text }}
						</button>
						<ng-container [ngTemplateOutlet]="summary"
									  [ngTemplateOutletContext]="{ 
										vesselStop: item.stop, 
										vesselMovement: item.arrivalMovementToStop, 
										stopType: item.label, 
										stopNumber: item.stopNumber, 
										inEditMode: !readonly(),
										indexInArray: item.indexInArray}">
						</ng-container>
					}

				}
				</ol>
			}
			<ol>
				<div class="bg-green noa__icon"></div>
			</ol>
		</ul>
		<kendo-progressbar [min]="1"
						   [max]="safeStepsLength()"
						   [indeterminate]="false"
						   [value]="progressBarPosition()"
						   [label]="false"></kendo-progressbar>
	</div>
	<div class="noa__location">
		<span>NPOC</span><br>
		<b>{{ NPOC() }}</b>
	</div>
</div>

<ng-template #summary
			 let-vesselStop="vesselStop"
			 let-vesselMovement="vesselMovement"
			 let-stopType="stopType"
			 let-stopNumber="stopNumber"
			 let-inEditMode="inEditMode"
			 let-indexInArray="indexInArray">
	<div class="noa__summary">
		<!-- <pmis3-vessel-visit-stepper-stop-summary [vesselActivityPairs]="pairedVesselActivities()"
												 [vesselPairId]="vesselStopId"></pmis3-vessel-visit-stepper-stop-summary> -->
		<pmis3-vessel-visit-stepper-stop-summary 
			[vesselStop]="vesselStop"
			[vesselMovement]="vesselMovement"
			[stopType]="stopType"
			[stopNumber]="stopNumber"
			[stopIndex]="indexInArray"
			[inEditMode]="inEditMode"
		></pmis3-vessel-visit-stepper-stop-summary>
	</div>
</ng-template>






